import { Group, User, UserRole } from '../domain/users';

export const mockClients = [
  {
    id: '1',
    name: 'Client 1',
    slug: 'client-1',
    language: 'es-AR',
    logoUrl:
      'https://i0.wp.com/lecturassumergidas.com/wp-content/uploads/2015/03/bbc-logo.png?fit=620%2C444&ssl=1',
  },
];

export const mockStations = [
  {
    id: '1',
    name: 'Station 1',
    slug: 'station-1',
    language: 'es-AR',
    timezone: 'America/Buenos_Aires',
    format: 'mp3',
    logoUrl: null,
    streams: [
      {
        main: true,
        url: 'http://stream.live',
      },
    ],
  },
  {
    id: '2',
    name: 'Station 2',
    slug: 'station-2',
    language: 'es-AR',
    timezone: 'America/Buenos_Aires',
    streams: [],
    format: 'mp3',
    logoUrl: 'https://pbs.twimg.com/profile_images/1214587509138743296/MCdWa3TF_400x400.jpg',
  },
  {
    id: '3',
    name: 'Station 3',
    slug: 'station-3',
    language: 'es-ES',
    timezone: '+01:00',
    streams: [],
    format: 'mp3',
    logoUrl: null,
  },
  {
    id: '4',
    name: 'Station 4',
    slug: 'station-4',
    language: 'es-AR',
    timezone: 'America/Buenos_Aires',
    format: 'mpegts',
    logoUrl: null,
    streams: [
      {
        main: true,
        url: 'http://stream.live',
      },
    ],
  },
] as any;

export const mockUsers: readonly User[] = [
  {
    id: 'user1',
    email: 'user1@mediainbox.io',
    role: UserRole.CLIENT_USER,
    groupId: null,
    name: 'John',
    surname: 'Smith',
  },
  {
    id: 'user2',
    email: 'user2@mediainbox.io',
    role: UserRole.CLIENT_USER,
    groupId: null,
    name: 'Maria',
    surname: 'Johnson',
  },
  {
    id: 'user3',
    email: 'user3@mediainbox.io',
    role: UserRole.CLIENT_USER,
    groupId: null,
    name: '',
    surname: '',
  },
  {
    id: 'user4',
    email: 'user4@mediainbox.io',
    role: UserRole.CLIENT_USER,
    groupId: null,
    name: '',
    surname: '',
  },
  {
    id: 'admin1',
    email: 'admin1@mediainbox.io',
    role: UserRole.CLIENT_ADMIN,
    groupId: null,
    name: 'Alice',
    surname: 'Jones',
  },
];

export const mockGroups: readonly Group[] = [
  {
    id: 'group1',
    name: 'Stations Group A users',
  },
  {
    id: 'group2',
    name: 'Stations Group B users',
  },
];
